module.exports = __webpack_public_path__ + "img/HCMTX_Android.f19f43ac.png";